import { useEffect, useState } from 'react';
import { useTwilioAppState } from '../state/';
import useDominantSpeaker from './useDominantSpeaker';
import useVideoContext from './useVideoContext';
import { Logger } from '../utils';

export default function useParticipants() {
  const { room } = useVideoContext();
    const dominantSpeaker = useDominantSpeaker();
    const [participants, setParticipants] = useState(room && room.participants && room.participants.values() ? Array.from(room.participants.values()) : []);
    const [showWaitingMsg, setShowWaitingMsg] = useState(false);
    const { _isMounted } = useTwilioAppState();
  // When the dominant speaker changes, they are moved to the front of the participants array.
  // This means that the most recent dominant speakers will always be near the top of the
  // ParticipantStrip component.
  useEffect(() => {
      if (dominantSpeaker && _isMounted && _isMounted.current === true) {
          setParticipants(prevParticipants => [
            dominantSpeaker,
            ...prevParticipants.filter(participant => participant !== dominantSpeaker),
          ]);
      }
  }, [dominantSpeaker, _isMounted]);

    useEffect(() => {
        const updatedParticipantList = room && room.participants && room.participants.values() ? Array.from(room.participants.values()) : [];       
        if (_isMounted && _isMounted.current === true) {
            setParticipants(updatedParticipantList);
            setShowWaitingMsg(updatedParticipantList.length === 0 ? true : false);
        }

        const participantConnected = participant => {
            Logger("UI.Twilio.Participant.Connected", new Date(), { "participant": participant });
          setParticipants(prevParticipants => [...prevParticipants, participant]);          
          setShowWaitingMsg(false);
      };

      const participantDisconnected = participant => {
          Logger("UI.Twilio.Participant.DisConnected", new Date(), { "participant": participant });
          setParticipants(prevParticipants => prevParticipants.filter(p => p !== participant));         
          setShowWaitingMsg(false);
      };
    room.on('participantConnected', participantConnected);
    room.on('participantDisconnected', participantDisconnected);
    return () => {
      room.off('participantConnected', participantConnected);
      room.off('participantDisconnected', participantDisconnected);
        };
    }, [room, _isMounted]);

    return {participants, showWaitingMsg };
}
